import { render } from "./AddGalleryItem.vue?vue&type=template&id=4dfbd610&scoped=true"
import script from "./AddGalleryItem.vue?vue&type=script&lang=js"
export * from "./AddGalleryItem.vue?vue&type=script&lang=js"

import "./AddGalleryItem.vue?vue&type=style&index=0&id=4dfbd610&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfbd610"]])

export default __exports__